/**
 * FILE: apps/hub/src/hooks/queries/useStaffQueries.ts
 * PURPOSE: React Query hooks for staff, roles, and course-attempt reads.
 * AGENT_CONTEXT: Use these hooks in components — never call services directly from JSX.
 */

import { useQuery } from '@tanstack/react-query'
import { getCustomRoles } from '@fintree/supabase/roles'
import { getStaffMembers } from '@fintree/supabase/staff'
import { fetchAllActiveAttempts } from '@fintree/supabase/course-attempts'
import { QK } from '@/lib/queryKeys'

/* ------------------------------------------------------------------ */
/* Custom roles                                                         */
/* ------------------------------------------------------------------ */

export function useCustomRoles() {
  return useQuery({
    queryKey: QK.customRoles(),
    queryFn: () => getCustomRoles(),
  })
}

/* ------------------------------------------------------------------ */
/* Staff members                                                        */
/* ------------------------------------------------------------------ */

export function useStaffMembers() {
  return useQuery({
    queryKey: QK.staffMembers(),
    queryFn: () => getStaffMembers(),
  })
}

/* ------------------------------------------------------------------ */
/* Course attempts                                                      */
/* ------------------------------------------------------------------ */

export function useCourseAttemptsAll() {
  return useQuery({
    queryKey: QK.courseAttemptsAll(),
    queryFn: () => fetchAllActiveAttempts(),
  })
}
